import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import { Shopfront } from "services/cms/models/shopfront";
import { ResolvedImage } from "./imageResolver";

type ShopfrontView = "carousel" | "from";

export type ResolvedShopfront = {
    codename: string;
    type: ContentTypeCodenames.Shopfront;
    vehicleCodename: string;
    view: ShopfrontView;
    carouselView: {
        headingPrefixText: string;
        ctaPrefixText: string;
        ctaButtonTarget: string;
        vehicleCardTarget: string;
    };
    fromView: {
        ctaPrefixText: string;
        fromCardTarget: string;
        overriddenImage: ResolvedImage | null;
    };
};

const shopfrontResolver = (item: Shopfront): ResolvedShopfront => {
    const {
        vehicle,
        view,
        headingPrefixText,
        ctaPrefixText,
        ctaButtonTarget,
        vehicleCardTarget,
        overriddenImage,
        fromCtaPrefixText,
    } = item.elements;
    return {
        type: ContentTypeCodenames.Shopfront,
        codename: item.system.codename,
        view: view.value[0].codename as ShopfrontView,
        vehicleCodename: vehicle.value[0].codename,
        carouselView: {
            headingPrefixText: headingPrefixText?.value ?? "Browse",
            ctaPrefixText: ctaPrefixText?.value ?? "Browse all",
            ctaButtonTarget: ctaButtonTarget?.value ?? "",
            vehicleCardTarget: vehicleCardTarget?.value ?? "",
        },
        fromView: {
            ctaPrefixText: fromCtaPrefixText?.value ?? "Browse",
            fromCardTarget: vehicleCardTarget?.value ?? "",
            overriddenImage:
                overriddenImage && overriddenImage?.value[0]
                    ? {
                          src: overriddenImage?.value[0]?.url ?? "",
                          alt: overriddenImage?.value[0]?.description ?? "",
                          focalPoint: "center",
                          type: ContentTypeCodenames.Image,
                          codename: item.system.codename,
                      }
                    : null,
        },
    };
};

export default shopfrontResolver;
